'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require('materialize-css');
require('jquery-lazy');
require('slick-carousel');
require('sweetalert');
require('./jquery.waypoints.min');
require('./contact');
var contLogin,campo,emailRegex;

$(function($) {
    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
});

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.sidenav').sidenav({
        edge: 'left'
    });
    $(".dropdown-trigger").dropdown({
        hover: false,
    });
    $('.modal').modal();
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});

$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
});
$('.clickContact').click(function () {
    $('html, body').animate({
        scrollTop: $('#contact2').offset().top - 100
    }, 1000);
});
$('.clickProducts').click(function () {
    $('html, body').animate({
        scrollTop: $('#products').offset().top - 100
    }, 1000);
});
$('.clickVideos').click(function () {
    $('html, body').animate({
        scrollTop: $('#videos').offset().top - 100
    }, 1000);
});

$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#ffffff', '!important');
            $('.header').addClass('header-shadow');
            $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo_down.svg');
            $('.header .brand-logo .desktop').addClass('desktop_down');
            $('.header .facebook').attr('src', https + 'img/header/face_down.svg');
            $('.header .instagram').attr('src', https + 'img/header/ins_down.svg');
            $('.header .globe').attr('src', https + 'img/header/globedown.svg');

            $('.header').css('height', '85px', '!important');
            $('.header').css('line-height', '85px', '!important');
            $('.header .line').css('visibility', 'hidden', '!important');
            $('.header a').css('color', '#00593E', '!important');
            $('.header .buton').css('margin', '9% 5%', '!important');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header').removeClass('header-shadow');
                $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo.svg');
                $('.header .brand-logo .desktop').removeClass('desktop_down');
                $('.header .facebook').attr('src', https + 'img/header/face.svg');
                $('.header .instagram').attr('src', https + 'img/header/ins.svg');
                $('.header .globe').attr('src', https + 'img/header/globe.svg');

                $('.header').css('height', '100px', '!important');
                $('.header').css('line-height', '100px', '!important');
                $('.header .line').css('visibility', 'inherit', '!important');
                $('.header a').css('color', '#ffffff', '!important');
                $('.header .buton').css('margin', '11% 5%', '!important');
            }
        }
    }
});

$(document).ready(function () {
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
    });
    /*
    $('#sliderBlog').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        prevArrow: '.backblog',
        nextArrow: '.nextblog',
        responsive: [
            {
                breakpoint: 500,
                settings:{
                    slidesToShow: 1,
                }
            }
        ]
    })
     */

    $('#sliderBanner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        $(".sectionBanner img").css('transition','transform 0s');
        $(".sectionBanner img").css('transform','scale(1.1)');
        //$(".sectionBanner .element").removeClass('animated fadeInUp');
        //$(".sectionBanner .element").addClass('animated fadeOutLeft');
    });
    $('#sliderBanner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function () {
            $(".sectionBanner img").css('transition','transform 4s');
            $(".sectionBanner img").css('transform','scale(1)');
            //$(".sectionBanner .element").removeClass('animated fadeOutLeft');
            //$(".sectionBanner .element").addClass('animated fadeInUp');
        },100);
    });


    $('#sliderVideo').slick({
        dots: false,
        infinite: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        prevArrow: $('.sectionVideo .arrows .prev'),
        nextArrow: $('.sectionVideo .arrows .next'),
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            },
        ]
    });

/*
    setTimeout(function () {
    var access_token = location.hash.split('=')[1];
    var URL_API_INSTAGRAM = "https://api.instagram.com/v1/users/"+instagram_id+"/media/recent/?count=15&access_token="+instagram_token+"&callback=?";
    $.getJSON(URL_API_INSTAGRAM,function(data) {
        var i = 1;
        $('.instragramImages').html("");
        $.each(data.data, function (item, value) {
            if (i <= 8) {
                $('.instragramImages').append('' +
                    '<div class="col s6 m3 l3 col-instagram">' +
                    '<a target="_blank" href="' + data.data[item].link + '">' +
                    '   <div class="containerInstagram">' +
                    '       <div class="img">'+
                    '           <img class="lazy" src="' + value.images.low_resolution.url + '" alt="">' +
                    '       </div>'+
                    '   </div>' +
                    '</a>' +
                    '</div>');
            }
            i++;
        });
    });
    },100);
    */
});

$('.sectionVideo #sliderVideo .video .btn').click(function () {
    document.getElementById('video_'+this.id).play();
    $('.sectionVideo #sliderVideo .video #video_'+this.id).css('visibility','initial');
    $('.sectionVideo #sliderVideo .video .img_'+this.id).css('visibility','hidden');
    $('.sectionVideo #sliderVideo .video .btn_'+this.id).css('visibility','hidden');
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});


if ($(window).width() > 991) {
    $('.sectionAbout .info').css('visibility', 'hidden');
    $('.sectionAbout img').css('visibility', 'hidden');
    $('.sectionProducts h1').css('visibility', 'hidden');
    $('.sectionProducts h2').css('visibility', 'hidden');
    $('.sectionProducts .element').css('visibility', 'hidden');
    $('.sectionVideo .info').css('visibility', 'hidden');
    $('.sectionVideo .sliderVideo').css('visibility', 'hidden');
    $('.sectionInstagram h1').css('visibility', 'hidden');
    $('.sectionInstagram .instragramImages').css('visibility', 'hidden');
}
$(window).scroll(function() {
    if ($(window).width() > 991) {
        $('.sectionAbout').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionAbout .info').css('visibility', 'inherit');
                    $('.sectionAbout .info').addClass('animated slideInLeft');
                    setTimeout(function () {
                        $('.sectionAbout img').css('visibility', 'inherit');
                        $('.sectionAbout img').addClass('animated slideInUp');
                    }, 500);
                }, 200);
            }
        }, {offset: '75%'});


        $('.sectionProducts').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionProducts h1').css('visibility', 'inherit');
                    $('.sectionProducts h1').addClass('animated slideInLeft');
                    $('.sectionProducts h2').css('visibility', 'inherit');
                    $('.sectionProducts h2').addClass('animated slideInLeft');
                    setTimeout(function () {
                        $('.sectionProducts .element').css('visibility', 'inherit');
                        $('.sectionProducts .element').addClass('animated slideInUp');
                    }, 500);
                }, 200);
            }
        }, {offset: '75%'});


        $('.sectionProducts h2').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionProducts .element').css('visibility', 'inherit');
                    $('.sectionProducts .element').addClass('animated slideInUp');
                }, 200);
            }
        }, {offset: '75%'});


        $('.sectionVideo').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionVideo .info').css('visibility', 'inherit');
                    $('.sectionVideo .info').addClass('animated slideInLeft');
                    setTimeout(function () {
                        $('.sectionVideo .sliderVideo').css('visibility', 'inherit');
                        $('.sectionVideo .sliderVideo').addClass('animated slideInRight');
                    }, 200);
                }, 200);
            }
        }, {offset: '75%'});

        $('.sectionInstagram').waypoint(function (direction) {
            if (direction === 'down') {
                setTimeout(function () {
                    $('.sectionInstagram h1').css('visibility', 'inherit');
                    $('.sectionInstagram h1').addClass('animated fadeInUp');
                    setTimeout(function () {
                        $('.sectionInstagram .instragramImages').css('visibility', 'inherit');
                        $('.sectionInstagram .instragramImages').addClass('animated rotateInUpLeft');
                    }, 500);
                }, 200);
            }
        }, {offset: '75%'});
    }
});

$('.sectionProducts .element').click(function () {
    $('#modalProducts_'+this.id).modal('open');
});
$('.sectionBlog .element').click(function () {
    $('#modalBlog_'+this.id).modal('open');
});

var instagram_count = 1;
$(window).scroll(function() {
    if(elementVisible( $('.sectionInstagram') )){
        if(instagram_count == 1){
            instagram_count = 2;
            getInstagram();
        }
    }
});

function elementVisible(element){
    var visible = true;
    var windowTop = $(document).scrollTop();
    var windowBottom = windowTop + window.innerHeight;
    var elementPositionTop =  $(element).offset().top;
    var elementPositionBottom = elementPositionTop + $(element).height();
    if (elementPositionTop >= windowBottom || elementPositionBottom <= windowTop) {
        visible = false;
    }
    return visible;
}
function getInstagram() {
    //return false;
    var token_instagram = 'IGQVJVUXQtdWlwRHY0S1ZA4c3VlSEhjYXJxRjBidUx0eWRUTGV4RnNERlpjS0NFTHQzZAnQtSG5zdDRoVFMySmNjaTlwYTEzWmhFYl9BQVc2amNwOHRhU0RFOUdxQlYzSm05RC11QUl2QjAtQ1FpT1ZAKeQZDZD';
    var URL_API_INSTAGRAM = "https://graph.instagram.com/me?fields=username,media&access_token="+token_instagram;
    $.getJSON(URL_API_INSTAGRAM, function (data) {
        var i = 1;
        var url_instagram = '';
        $('.instragramImages2').html("");
        $.each(data.media.data, function (item, value) {
            if (i <= 6) {
                var MediaInstagram = "https://graph.instagram.com/"+value.id+"?fields=caption,media_url,media_type,id,permalink,thumbnail_url&access_token="+token_instagram;
                $.getJSON(MediaInstagram, function (data_media) {
                    if(data_media.media_type == 'VIDEO'){
                        url_instagram = data_media.thumbnail_url;
                    }else{
                        url_instagram = data_media.media_url;
                    }
                    $('.instragramImages2').append('' +
                      '                                <div class="inst">\n' +
                      '                                    <a target="_blank" href="'+data_media.permalink+'">\n' +
                      '                                        <div class="containerInstagram">\n' +
                      '                                            <div class="img">\n' +
                      '                                                <img src="'+url_instagram+'" alt="">\n' +
                      '                                            </div>\n' +
                      '                                        </div>\n' +
                      '                                    </a>\n' +
                      '                                </div>');
                });
            }
            i++;
        });
    });
}
